const checkIfEmail = (input: string) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(input.toLowerCase());
};

const checkIfValidPassword = (input: string) => {
  return input.length >= 8;
};

const checkIfURL = (input: string) => {
  const re =
    /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www\.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w\-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[.!/\\\w]*))?)/;
  return re.test(input);
};

const checkIfVideo = (input: string) => {
  const result = input.match(
    '^(http:\\/\\/|https:\\/\\/)(vimeo\\.com|youtu\\.be|www\\.youtube\\.com)\\/([\\w\\/]+)([\\?].*)?$'
  );
  return result !== null ? (result.length > 0 ? true : false) : false;
};

export type ValidationFunctions = {
  required: (value: string) => any;
  isEmail: (required?: boolean) => (value: string) => any;
  isValidPassWord: (value: string) => any;
  match: (match: string) => (value: string) => any;
  isURL: (value: string) => any;
  isVideo: (value: string) => any;
};

const validations = (t: any) => {
  const validation: ValidationFunctions = {
    required: (value: string) => (value ? undefined : t('shared.forms.validations.required')),
    isEmail:
      (required: boolean = true) =>
      (value: string) =>
        value
          ? checkIfEmail(value)
            ? undefined
            : t('shared.forms.validations.email')
          : required
          ? t('shared.forms.validations.required')
          : undefined,
    isValidPassWord: (value: string) =>
      value
        ? checkIfValidPassword(value)
          ? undefined
          : t('shared.forms.validations.invalidPassword')
        : t('shared.forms.validations.required'),
    match: (match: string) => (value: string) =>
      value && value === match ? undefined : t('shared.forms.validations.passwordMatch'),
    isURL: (value: string) =>
      value
        ? checkIfURL(value)
          ? undefined
          : t('shared.forms.validations.url')
        : t('shared.forms.validations.required'),
    isVideo: (value: string) =>
      value
        ? checkIfVideo(value)
          ? undefined
          : t('shared.forms.validations.url')
        : t('shared.forms.validations.required'),
  };
  return validation;
};

export default validations;
